export const allClasses = [
    {id:0,name:'Economy'},
    {id:1,name:'Business'},
    {id:2,name:'First Class'},
    {id:3,name:'Premium Economy'}
];